<script>
import axios from "axios";
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import { RG_RECIPE_PATH } from "../../../../../path";
import Swal from "sweetalert2";
export default {
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Recipe",
      items: [
        {
          text: "List",
        },
        {
          text: "Management",
          active: true,
        },
      ],
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      search: "",
      currentPage: 1,
      data: [],
      fields: [
        "recipe_name",
        "description",
        "batch_size",
        "type_of_recipe",
        "version",
        "actions",
      ],
      selectedRecipe: null,
      status: "testing",
    };
  },
  watch: {
    status() {
      this.getData();
    },
    currentPage() {
      this.getData();
    },
    search() {
      this.getData();
    },
  },
  methods: {
    async getData() {
      try {
        let res = await axios.get(this.base_url + RG_RECIPE_PATH.GET, {
          params: {
            search: this.search,
            page: this.currentPage,
            status: this.status,
          },
        });
        if (res.data.status) {
          this.data = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    addNewVersion(v) {
      this.$router.push({
        name: "Add R-G Recipe",
        params: {
          recipe_id: v.id,
          version: v.version + 1,
        },
      });
    },
    editData(v) {
      this.$router.push({
        name: "Add R-G Recipe",
        params: {
          recipe_id: v.id,
          version: v.version,
        },
        query: {
          isEdit: true,
        },
      });
    },
    moveToProduction(v) {
      this.$router.push({
        name: "Add R-G Recipe",
        params: {
          recipe_id: v.id,
          version: v.version,
        },
        query: {
          production: true,
        },
      });
    },
    async deleteData(v) {
      try {
        let res = await axios.post(this.base_url + RG_RECIPE_PATH.DELETE, {
          id: v.id,
        });
        if (res.data.status) {
          Swal.fire("Deleted Successfully");
          this.getData();
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <router-link to="/add_raw_material_to_gravy_recipe"
      ><b-button variant="secondary">Add Recipe</b-button></router-link
    >
    <b-row style="margin-top: 20px">
      <b-col>
        <label class="d-inline-flex align-items-center mr-5">
          Search:
          <b-form-input
            v-model="search"
            type="search"
            debounce="300"
            class="form-control form-control-sm ml-2"
          ></b-form-input>
        </label>
      </b-col>
    </b-row>
    <b-card>
      <b-tabs>
        <b-tab
          title="Test Library"
          @click="() => (this.status = 'testing')"
        ></b-tab>
        <b-tab
          title="Production"
          @click="() => (this.status = 'production')"
        ></b-tab>
      </b-tabs>
      <b-table
        :key="data.key"
        :items="data.data"
        :fields="fields"
        responsive="sm"
        :current-page="currentPage"
      >
        <template v-slot:cell(actions)="row">
          <b-button
            v-b-tooltip.hover
            title="Create New Version"
            style="margin-right: 10%"
            variant="primary"
            @click="addNewVersion(row.item)"
            ><i class="fa fa-copy"></i
          ></b-button>
          <b-button
            v-b-tooltip.hover
            v-if="row.item.status == 'testing'"
            title="Move To Production"
            style="margin-right: 10%"
            variant="primary"
            @click="moveToProduction(row.item)"
            ><i class="fa fa-upload"></i
          ></b-button>
          <b-button
            style="margin-right: 10%"
            variant="primary"
            @click="editData(row.item)"
            ><i class="fa fa-pen"></i
          ></b-button>
          <b-button variant="danger" @click="deleteData(row.item)"
            ><i class="fa fa-trash"></i
          ></b-button>
        </template>
      </b-table>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                :key="data.key"
                v-model="currentPage"
                :total-rows="data.total"
                :per-page="data.per_page"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-card>
  </Layout>
</template>

<style></style>
